import BasicRepository from "./basicRepository";
import Client from "../client";
import { LicenseResource, LicenseStatusResource } from "client/resources";

class LicenseRepository extends BasicRepository<LicenseResource, LicenseResource> {
    constructor(client: Client) {
        super("Licenses", client);
    }
    getCurrent() {
        return this.client.get<LicenseResource>(this.client.getRootDocument().Links["CurrentLicense"]);
    }
    getCurrentStatus() {
        return this.client.get<LicenseStatusResource>(this.client.getRootDocument().Links["CurrentLicenseStatus"]);
    }
}

export default LicenseRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/licenseRepository.ts